import { render } from "./XMarkIcon.vue?vue&type=template&id=7b37f00e"
import script from "./XMarkIcon.vue?vue&type=script&lang=js"
export * from "./XMarkIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__